// Scheduled payments, from /api/v1/admin/schedules
// (Hethera docs/scheduled-payments-acceptance-criteria.md S4.5, D29, D30).
// Money fields are Decimal strings; Number() them before formatting.

export type ScheduleStatus = 'ACTIVE' | 'PAUSED' | 'CANCELLED' | 'COMPLETED';

export const SCHEDULE_STATUS_OPTIONS: ScheduleStatus[] = ['ACTIVE', 'PAUSED', 'COMPLETED', 'CANCELLED'];

export const SCHEDULE_KIND_LABELS: Record<string, string> = {
  ONCE: 'Once',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  BEFORE_EXPIRY: 'Before expiry',
};

export const PAUSE_REASON_LABELS: Record<string, string> = {
  USER: 'Paused by user',
  TOO_MANY_FAILURES: 'Two declines in a row',
  CARD_CHANGED: 'New card added',
  CARD_EXPIRED: 'Card expired',
  CARD_NEEDS_CONFIRMATION: 'Card needs confirming',
  CARD_UNUSABLE: 'Card unusable',
  NO_CARD: 'No card',
  DISPUTE: 'Chargeback',
  ACCOUNT_BLOCKED: 'Account blocked',
  BENEFICIARY_CHANGED: 'Recipient changed',
};

export interface ScheduleRow {
  id: string;
  code: string;
  user_id: string;
  chat_id: string | null;
  name: string;
  bill_type: string;
  service_id: string;
  identifier: string;
  amount: string;
  max_amount: string;
  kind: string;
  next_run_date: string | null;
  status: ScheduleStatus;
  pause_reason: string | null;
  failures_in_a_row: number;
  created_at: string;
}

export interface ScheduleRun {
  id: string;
  due_date: string;
  due_at: string;
  status: string;
  skip_reason: string | null;
  failure_kind: string | null;
  amount: string | null;
  transaction_id: string | null;
  pay_now_transaction_id: string | null;
  transaction_reference: string | null;
  pay_now_reference: string | null;
  notice_sent_at: string | null;
  result_sent_at: string | null;
}

export interface ScheduleAudit {
  event_type: string;
  previous_status: string | null;
  new_status: string | null;
  audit_metadata: Record<string, unknown> | null;
  actor: string | null;
  created_at: string;
}

export interface ScheduleDetail extends ScheduleRow {
  card_id: string | null;
  beneficiary_id: string | null;
  run_time: string;
  consented_at: string | null;
  runs: ScheduleRun[];
  audits: ScheduleAudit[];
}

// D30: everything behind one scheduled charge, for a chargeback.
export interface ScheduleDisputeRecord {
  transaction_reference: string;
  schedule_code: string;
  run_due_date: string | null;
  consent: ScheduleAudit[];
  notice_sent_at: string | null;
  result_sent_at: string | null;
  text: string;
}
